module.exports = __webpack_public_path__ + "img/s.66d4cbd3.jpg";